module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/regenerator/index.js
// module id = 266
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/regenerator/index.js